import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { GetNotificationsModel } from '@app/api/api-models/notifications/GetNotificationsModel';
import { CadQuestionerResponseApiModel, NotificationItemApiModel } from '@app/api/api-models';
import { NotificationStateAction } from '@app/shared/models/notification-state-action.model';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class NavNotificationsService {
  public apiUrl = 'notifications';
  public isNotificationsOpen = false;
  public notificationsStateObserver = new Subject<boolean>();
  public counterObserver = new Subject<number>();
  public notificationStateActionObserver = new Subject<NotificationStateAction>();

  constructor(private readonly http: HttpClientService) {}

  public emitNotificationStateActionObserver(model?: NotificationStateAction): void {
    this.notificationStateActionObserver.next(model);
  }

  public subscribeNotificationStateActionObserver(): Observable<NotificationStateAction> {
    return this.notificationStateActionObserver.asObservable();
  }

  public emitNotificationsStateObserver(isOpen: boolean): void {
    this.isNotificationsOpen = isOpen;
    this.notificationsStateObserver.next(this.isNotificationsOpen);
  }

  public subscribeNotificationsStateObserver(): Observable<boolean> {
    return this.notificationsStateObserver.asObservable();
  }

  public emitCounterObserver(totalCount: number): void {
    this.counterObserver.next(totalCount);
  }

  public subscribeCounterObserver(): Observable<number> {
    return this.counterObserver.asObservable();
  }

  public closeNotifications(): void {
    this.emitNotificationsStateObserver(false);
  }

  public getCounters(): Observable<any> {
    return this.http.get(`${this.apiUrl}/get-counters`);
  }

  public get(model: GetNotificationsModel): Observable<NotificationItemApiModel[]> {
    return this.http.get<NotificationItemApiModel[]>(`${this.apiUrl}/get`, { params: model as any });
  }

  public getById(id: number): Observable<NotificationItemApiModel> {
    return this.http.get<NotificationItemApiModel>(`${this.apiUrl}/get/${id}`);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}`);
  }

  public deleteAll(): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete-all`);
  }

  public markAsRead(id: number): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/mark-as-read/${id}`, {});
  }

  public markAllAsRead(): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/mark-all-as-read`, {});
  }

  public showCadQuestionerCard(): Observable<CadQuestionerResponseApiModel> {
    return this.http.get<CadQuestionerResponseApiModel>(`${this.apiUrl}/cad-release`);
  }
}
